import { createRouter, createWebHistory } from 'vue-router'
import Login from '../components/auth/LoginComponent.vue'
import test from '../components/FactureComponent.vue'
import profil from '../components/profil/ProfilComponent.vue'
import MesCommandes from '../components/profil/MesCommandes/MesCommandesComponent.vue'
import RecusEncoursLivraison from '../components/profil/MesCommandes/RecusEnCourLivraisonComponent.vue'
import RecusEnCourRecuperation from '../components/profil/MesCommandes/RecusEnCourRecuperationComponent.vue'
import RecusValides from '../components/profil/MesCommandes/RecusValidesComponent.vue'
import RecusAnnules from '../components/profil/MesCommandes/RecusAnnulesComponent.vue'
import TousMesCommandes from '../components/profil/MesCommandes/ToutMesCommandesComponent.vue'
import JoursFeries from '../components/profil/JoursFeriesComponent.vue'

const routes = [
  {
    path: '/',
    component: Login
  },

  {
    path: '/test',
    component: test
  },
  {
    path: '/profil',
    name: 'profil',
    component: profil,
    redirect: { name: 'MesCommandes' },
    children: [
      {
        path: '/MesCommandes',
        name: 'MesCommandes',
        components: {
          default: profil,
          two: MesCommandes
        },
        redirect: { name: 'MesCommandes' },
        children: [
          {
            path: '',
            name: 'tous_mes_commande',
            components: {
              default: MesCommandes,
              seven: TousMesCommandes
            }
          },
          {
            path: '/recus-en-cours-livraison',
            name: 'recus-en-cours-livraison',
            components: {
              default: MesCommandes,
              seven: RecusEncoursLivraison
            }
          },
          {
            path: '/recus-en-cours-recuperation',
            name: 'recus-en-cours-recuperation',
            components: {
              default: MesCommandes,
              seven: RecusEnCourRecuperation
            }
          },


          {
            path: '/recus-valides',
            name: 'recus-valides',
            components: {
              default: MesCommandes,
              seven: RecusValides
            }
          },

          {
            path: '/recus-annules',
            name: 'recus-annules',
            components: {
              default: MesCommandes,
              seven: RecusAnnules
            }
          },
        ]
      },
      {
        path: '/jours-feries',
        name: 'jours-feries',
        components: {
          default: profil,
          two: JoursFeries
        }
      },


    ]
  },

]
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
